"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCode = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M8.707 16.213a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414L7.294 6.21a1 1 0 111.414 1.414L4.414 11.92l4.293 4.293zm6.587 0l4.293-4.293-4.294-4.295a1 1 0 111.414-1.414l5.001 5.002a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414zm-4.647 3.57c-.656-.118-.926-.504-.81-1.158l2.43-13.788c.113-.657.5-.927 1.16-.81.662.116.932.502.81 1.158l-2.43 13.785c-.117.66-.503.93-1.16.813z' }))); };
exports.default = SvgCode;
//# sourceMappingURL=Code.js.map